import React, { useState } from "react";
import { MessageCircle, Send, X } from "lucide-react";
import "./index.css";

const WhatsappButton = () => {
  const [isOpen, setIsOpen] = useState(false);

  const whatsappNumber = "919739965504";

  const message =
    "Hello, Vajra Dental, I would like to book an appointment. Please share available slots. Thank you!.";

  const whatsappLink = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(
    message
  )}`;

  return (
    <div className="whatsapp-wrapper">
      {/* Chat Box */}
      <div className={`whatsapp-popup ${isOpen ? "show" : ""}`}>
        <div className="whatsapp-header">
          <div>
            <h4>Chat with us</h4>
            <p>We’re here to help</p>
          </div>

          <button
            className="whatsapp-close"
            onClick={() => setIsOpen(false)}
            aria-label="Close WhatsApp chat"
          >
            <X size={20} />
          </button>
        </div>

        <div className="whatsapp-body">
          <div className="whatsapp-message">
            Hi 👋
            <br />
            How can we help you today?
          </div>

          <a
            href={whatsappLink}
            target="_blank"
            rel="noreferrer"
            className="whatsapp-send"
          >
            <span>Start WhatsApp Chat</span>
            <Send size={18} />
          </a>
        </div>
      </div>

      {/* Floating Button */}
      <button
        className={`floating-whatsapp ${isOpen ? "active" : ""}`}
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Chat on WhatsApp"
      >
        {isOpen ? (
          <X className="floating-message-icon" size={27} />
        ) : (
          <MessageCircle className="floating-message-icon" size={29} />
        )}
      </button>
    </div>
  );
};

export default WhatsappButton;